import styled from 'styled-components';
import title from '@/assets/title3.png';
import {BlockContainer} from '../layouts/style';
import bg from '@/assets/guide-item.png';
import bg2 from '@/assets/guide-item2.png';
import bg3 from '@/assets/guide-item3.png';
import bg4 from '@/assets/guide-item4.png';
import viewDetail from '@/assets/view-detail.png';
import Popup from '../components/Popup';
import {useState} from 'react';

const NewServerGuide = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const list = [
    {
      label: '新手入门',
      link: 'https://jx.xoyo.com/index1/detail.html?catid=3062&id=11162'
    },
    {
      label: '经典玩法',
      link: 'https://jx.xoyo.com/index1/detail.html?catid=3062&id=11163'
    },
    {label: '更多资料', link: 'https://jx.xoyo.com/index1/data.html'},
    {label: '官方视频', link: ''}
  ];

  const open = (link: string) => {
    if (link) window.open(link);
  };

  return (
    <Container>
      <img src={title} alt="" className="title" />
      <div className="list">
        {list.map(item => (
          <div className="item" key={item.label}>
            
            <img
              src={viewDetail}
              alt=""
              onClick={() => {
                if (item.link) open(item.link);
                else setVisible(true);
              }}
            />
          </div>
        ))}
      </div>
      <Popup
        visible={visible}
        onClose={() => setVisible(false)}
        title="适龄提示"
        content={
          <div className="center">
            <img src={require('@/assets/20230908-144307.jpg')} alt="" />
          </div>
        }
      />
    </Container>
  );
};

export default NewServerGuide;

const Container = styled(BlockContainer)`
  height: 46rem;
  position: relative;
  .title {
    width: 27.56rem;
    height: 12.93rem;
    margin-top: 23rem;
    margin-left: 1.1rem;
    
  }
  .list {
    position: absolute;
    width: 100%;
    height: 44%;
    top: 84%;
    left: -0.5%;
    display: flex;
    justify-content: space-around;
    .item {
      height: 15.875rem;
      width: 20.8125rem;
      background-size: contain;
      position: relative;
      background-repeat: no-repeat;
      background-position: top center;
    
      .font {
        font-family: '思源宋体';
        color: #983706;
        font-size: 2.5rem;
        position: absolute;
        left: 19.5%;
        top: 14%;
      }
      img {
        width: 12.25rem;
        height:3.125rem;
        position: absolute;
        bottom: -10%;
        left: 19.5%;
        cursor: pointer;
      }
    }
    .item:nth-child(1){
      background: url(${bg});
      height: 15.875rem;
      width: 20.8125rem;
      background-size: contain;
      position: relative;
      background-repeat: no-repeat;
      background-position: top center;
     }
    .item:nth-child(2){
      background: url(${bg2});
      height: 15.875rem;
      width: 20.8125rem;
      background-size: contain;
      position: relative;
      background-repeat: no-repeat;
      background-position: top center;
     }
    .item:nth-child(3){
      background: url(${bg3});
      height: 15.875rem;
      width: 20.8125rem;
      background-size: contain;
      position: relative;
      background-repeat: no-repeat;
      background-position: top center;
     }
    .item:nth-child(4){
      background: url(${bg4});
      height: 15.875rem;
      width: 20.8125rem;
      background-size: contain;
      position: relative;
      background-repeat: no-repeat;
      background-position: top center;
     }
  }
`;
